import './component.scss'

document.addEventListener('DOMContentLoaded', () => {
  initTargetConstructionsToggle()
})

function initTargetConstructionsToggle() {
  const toggleElements = document.querySelectorAll('[data-target-constructions-toggle]')

  toggleElements.forEach((toggleElement) => {
    toggleElement.addEventListener('click', (event) => {
      event.preventDefault()
      event.stopPropagation()

      const container = toggleElement.closest('[data-target-constructions]')
      if (!container) return

      // 3件目以降のアイテムを取得（index >= 2）
      const allItems = container.querySelectorAll('[data-target-constructions-item]')
      const hiddenItems = Array.from(allItems).slice(2)

      const moreButton = container.querySelector('[data-target-constructions-more]')
      const closeText = container.querySelector('[data-target-constructions-close]')

      const isExpanded = moreButton.style.display === 'none'

      if (isExpanded) {
        // 閉じる
        hiddenItems.forEach((item) => {
          item.classList.add('subsidies-summary-card__target-constructions-item--hidden')
        })
        moreButton.style.display = ''
        closeText.style.display = 'none'
      } else {
        // 開く
        hiddenItems.forEach((item) => {
          item.classList.remove('subsidies-summary-card__target-constructions-item--hidden')
        })
        moreButton.style.display = 'none'
        closeText.style.display = ''
      }
    })
  })
}
